(() => {
  if (window.SylavieSizeGuideUnitsInitialized) return;
  window.SylavieSizeGuideUnitsInitialized = true;

  const selectors = {
    guide: '[data-size-guide-units]',
    toggle: '[data-size-guide-unit-toggle]',
    button: '[data-size-guide-unit]',
    measurement: '[data-size-guide-measurement]',
    status: '[data-size-guide-unit-status]',
  };

  const updateGuide = (guide, unit) => {
    guide.querySelectorAll(selectors.button).forEach((button) => {
      const isSelected = button.dataset.sizeGuideUnit === unit;
      button.classList.toggle('is-active', isSelected);
      button.setAttribute('aria-pressed', String(isSelected));
    });

    guide.querySelectorAll(selectors.measurement).forEach((cell) => {
      const value = cell.dataset[unit];
      cell.textContent = unit === 'cm' ? `${value} cm` : `${value}"`;
    });

    const status = guide.querySelector(selectors.status);
    if (status) {
      status.textContent = `Measurements shown in ${unit === 'cm' ? 'centimetres' : 'inches'}.`;
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(selectors.button);
    if (!button) return;

    const guide = button.closest(selectors.guide);
    if (guide) updateGuide(guide, button.dataset.sizeGuideUnit);
  });

  document.addEventListener('keydown', (event) => {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

    const button = event.target.closest(selectors.button);
    const toggle = button?.closest(selectors.toggle);
    if (!button || !toggle) return;

    const buttons = Array.from(toggle.querySelectorAll(selectors.button));
    const currentIndex = buttons.indexOf(button);
    let nextIndex = event.key === 'ArrowLeft' ? currentIndex - 1 : currentIndex + 1;

    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = buttons.length - 1;

    nextIndex = (nextIndex + buttons.length) % buttons.length;
    event.preventDefault();
    buttons[nextIndex].focus();
    buttons[nextIndex].click();
  });
})();
